import { render } from "./EditRestaurantView.vue?vue&type=template&id=479ab513"
import script from "./EditRestaurantView.vue?vue&type=script&lang=js"
export * from "./EditRestaurantView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__